// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3m4Fo","pencil":"IconEdit_pencil__3KrfA"};